import styled from 'styled-components';
import {
  NAVIGATION_CSS_VARIABLES,
  TRANSITION_DURATION_MS,
} from '~/components/Navigation/constants';
import { navigationDefaultColors } from '~/components/Navigation/data';

export const StyledNavMenuHead = styled.div`
  display: flex;
  padding: 6px 8px;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  border-radius: 6px;
  flex-wrap: wrap;
  transition: padding ${TRANSITION_DURATION_MS}ms ease, width ${TRANSITION_DURATION_MS}ms ease,
    height ${TRANSITION_DURATION_MS}ms ease;

  .nav-menu-head-name {
    width: 167px;
  }

  .nav-menu-head-name-bottom {
    width: 55px;
  }

  .nav-menu-head-content-desktop {
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  .nav-menu-head-icon-wrapper {
    width: 16px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .nav-menu-head-icon {
      color: ${navigationDefaultColors.navMenuIconColor};
    }
  }

  .nav-menu-head-name {
    white-space: nowrap;
    color: ${navigationDefaultColors.navMenuNameColor};
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    flex-shrink: 0;

    &.nav-menu-head-name-active {
      color: ${navigationDefaultColors.navMenuNameActiveColor};
    }
  }

  &.expanded-navigation-menu-head {
    &.only-menu-item.nav-menu-active,
    &.only-menu-item.nav-menu-active:hover {
      background-color: var(
        ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_BG_COLOR},
        ${navigationDefaultColors.navRouteBgActiveColor}
      );
    }

    :hover {
      background-color: ${navigationDefaultColors.navMenuBgHoverColor};
    }
    .nav-menu-head-name-bottom {
      position: absolute;
      z-index: -1;
    }
  }

  &.collapsed-navigation-menu-head {
    gap: 1px;
    padding: 0;
    justify-content: center;

    .nav-menu-head-name {
      position: absolute;
      z-index: -1;
      left: 0;
    }

    .nav-menu-head-icon-wrapper {
      width: 32px;
      height: 32px;
      display: flex;
      border-radius: 6px;
      align-items: center;
      justify-content: center;
    }

    .nav-menu-head-name-bottom {
      text-align: center;
    }

    &.nav-menu-active {
      .nav-menu-head-icon-wrapper {
        background-color: var(
          ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_BG_COLOR},
          ${navigationDefaultColors.navRouteBgActiveColor}
        );

        .nav-menu-head-icon {
          color: var(
            ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_ICON_COLOR},
            ${navigationDefaultColors.navMenuIconActiveColor}
          );
        }
      }
    }

    &:hover {
      .nav-menu-head-icon-wrapper {
        background-color: ${navigationDefaultColors.navMenuBgHoverColor};
      }
      &.nav-menu-active {
        .nav-menu-head-icon-wrapper {
          background-color: var(
            ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_BG_COLOR},
            ${navigationDefaultColors.navRouteBgActiveColor}
          );
        }
      }
    }
  }

  &.nav-menu-active {
    .nav-menu-head-icon {
      color: var(
        ${NAVIGATION_CSS_VARIABLES.NAV_CONTAINER_ACTIVE_ICON_COLOR},
        ${navigationDefaultColors.navMenuIconActiveColor}
      );
    }
  }
`;
